import { useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { TresMotores } from "../components/TresMotores";
import { NodoSerrano } from "../components/NodoSerrano";
import { Servicios } from "../components/Servicios";
import { MetodoNodo } from "../components/MetodoNodo";
import { RaizCarbono } from "../components/RaizCarbono";
import { Formacion } from "../components/Formacion";
import { CursosPortal } from "../components/CursosPortal";
import { MarcoLGEC } from "../components/MarcoLGEC";
import { BibliotecaPDF } from "../components/BibliotecaPDF";
import { Contacto } from "../components/Contacto";
import { Footer } from "../components/Footer";
import { trackVisit } from "../lib/api";

export default function Landing() {
  useEffect(() => {
    trackVisit("/", "landing");
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, []);

  return (
    <div className="bg-rc-bg min-h-screen">
      <Navbar />
      <Hero />
      <TresMotores />
      <NodoSerrano />
      <Servicios />
      <MetodoNodo />
      <RaizCarbono />
      <Formacion />
      <CursosPortal />
      <MarcoLGEC />
      <BibliotecaPDF />
      <Contacto />
      <Footer />
    </div>
  );
}
